export var UserSubscriptionType;
(function (UserSubscriptionType) {
    UserSubscriptionType["P2IA"] = "P2IA";
    UserSubscriptionType["TNE"] = "TNE";
    UserSubscriptionType["CLASSIC"] = "CLASSIC";
    UserSubscriptionType["FR_AMBASSADOR"] = "FR_AMBASSADOR";
    UserSubscriptionType["US_AMBASSADOR"] = "US_AMBASSADOR";
    UserSubscriptionType["FR_INTERNAL"] = "FR_INTERNAL";
    UserSubscriptionType["US_INTERNAL"] = "US_INTERNAL";
    UserSubscriptionType["PARIS18"] = "PARIS18";
    UserSubscriptionType["GAR"] = "GAR";
})(UserSubscriptionType || (UserSubscriptionType = {}));
export var SchoolSubscriptionType;
(function (SchoolSubscriptionType) {
    SchoolSubscriptionType["CLASSIC"] = "CLASSIC";
    SchoolSubscriptionType["VONUM"] = "VONUM";
})(SchoolSubscriptionType || (SchoolSubscriptionType = {}));
export var VersionType;
(function (VersionType) {
    VersionType["TNE_BASIC_VERSION"] = "TNE_BASIC_VERSION";
    VersionType["TNE_FULL_VERSION"] = "TNE_FULL_VERSION";
    VersionType["P2IA_BASIC_VERSION"] = "P2IA_BASIC_VERSION";
    VersionType["P2IA_FULL_VERSION"] = "P2IA_FULL_VERSION";
    VersionType["CLASSIC_BASIC_VERSION"] = "CLASSIC_BASIC_VERSION";
    VersionType["CLASSIC_FULL_VERSION"] = "CLASSIC_FULL_VERSION";
    VersionType["FREE_TRIAL_VERSION"] = "FREE_TRIAL_VERSION";
    VersionType["FRANCE_FULL_VERSION"] = "FRANCE_FULL_VERSION";
})(VersionType || (VersionType = {}));
//# sourceMappingURL=licensing.js.map